import { render, staticRenderFns } from "./indexCommunity.vue?vue&type=template&id=b1025c5e&scoped=true"
import script from "./indexCommunity.vue?vue&type=script&lang=js"
export * from "./indexCommunity.vue?vue&type=script&lang=js"
import style0 from "./indexCommunity.vue?vue&type=style&index=0&id=b1025c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1025c5e",
  null
  
)

export default component.exports